import {t} from "@lingui/core/macro";

export const getContentKindLabelMap = () => ({
    AIGuideActivity: t`Khanmigo Activity`,
    Exercise: t`Exercise`,
    Article: t`Article`,
    Video: t`Video`,
    TopicUnitTest: t`Topic unit test`,
    TopicQuiz: t`Topic quiz`,
    Scratchpad: t`Scratchpad`,
    Challenge: t`Challenge`,
    Interactive: t`Interactive`,
    Project: t`Project`,
    Talkthrough: t`Talkthrough`,
    CourseChallenge: t`Course Challenge`,
});
